import styled from "styled-components";
import { type DisplayProps, type SpaceProps, type LayoutProps, display, space, layout } from "styled-system";
import * as Type from "../../../../../../../../common-deprecated/styles/v2/lexus/globals/Type";
import * as Flex from "../../../../../../../../common-deprecated/styles/v2/lexus/globals/Flex";
import * as Button from "../../../../../../../../common-deprecated/styles/v2/lexus/components/Button";
import IconWrapper from "../../../../../../../../common-deprecated/styles/v2/lexus/globals/IconWrapper";
import { getBreakpoint, getDirection } from "../../../../../../../../common-deprecated/themes/common";
import { theme as lexusTheme } from "../../../../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";

export const Wrapper = styled.div<{ isMobile?: boolean }>`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    margin: ${lexusTheme.space[4]}px 0;
    padding: ${lexusTheme.space[3]}px;
    background-color: ${lexusTheme.colors.mist};

    @media ${getBreakpoint("up", "lg")} {
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
    }
`;

export const WheelPreview = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
`;

export const ImageWrapper = styled.div<DisplayProps & SpaceProps>`
    position: relative;
    ${display};
    ${space};
`;

export const Badge = styled.div`
    position: absolute;
    top: 7px;
    ${getDirection("left")}: 10px;
    width: 20px;
    height: 20px;
    text-align: center;
    color: ${lexusTheme.colors.error};
    background: ${lexusTheme.colors.white};
    border: 1px solid rgba(32, 32, 32, 0.2);
    border-radius: 10px;
`;

export const WheelHeader = styled.div`
    padding-${getDirection("left")}: ${lexusTheme.space[2]}px;
`;

export const Name = styled.h2.attrs(() => ({
    className: "l-nano-headline",
}))`
    margin-bottom: ${lexusTheme.space[1]}px;
`;

export const Price = styled.div.attrs(() => ({
    className: "l-base-text",
}))`
    margin-bottom: 0;
    font-size: 1.4rem;
    line-height: 2rem;
    color: ${lexusTheme.colors.brushedSteel};
`;

export const OptionalText = styled.div.attrs(() => ({
    className: "l-nano-text",
}))`
    font-size: 1.4rem;
    line-height: 2rem;
    color: ${lexusTheme.colors.brushedSteel};
`;

export const AccordionTitle = styled.div<{ isOpen: boolean }>``;

export const Tab = styled.button.attrs({ type: "button" })<{ isActive: boolean }>``;

export const WheelButtonContainer = styled.div`
    width: 100%;
    margin-top: ${lexusTheme.space[3]}px;
    text-align: ${getDirection("right")};
`;

export const CardRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    border-${getDirection("left")}: 1px solid ${lexusTheme.colors.platinumLight};
    border-top: 1px solid ${lexusTheme.colors.platinumLight};
`;

export const Card = styled.div<LayoutProps>`
    position: relative;
    min-height: 100%;
    padding: ${lexusTheme.space[3]}px;
    border-bottom: 1px solid ${lexusTheme.colors.platinumLight};
    border-${getDirection("right")}: 1px solid ${lexusTheme.colors.platinumLight};
    ${layout}
`;

export const Header = styled.div`
    padding: ${lexusTheme.space[5]}px;
`;

export const Content = styled.div`
    padding: 0 ${lexusTheme.space[5]}px ${lexusTheme.space[5]}px;
`;

export const Footer = styled.div`
    padding: ${lexusTheme.space[5]}px;
    border-top: 1px solid ${lexusTheme.colors.platinumMedium};
`;

export const Actions = styled.div<{ columns: number }>`
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: ${({ columns }) => (columns === 1 ? "1fr" : "1fr 1fr")};
    row-gap: ${lexusTheme.space[2]}px;
    width: 100%;
    margin-top: ${lexusTheme.space[3]}px;
    text-align: center;

    ${Button.ButtonTertiary} {
        a, button {
            width: 100%;
            font-family: ${lexusTheme.fonts.book};
            font-size: 1.8rem;
            line-height: 3rem;
            text-transform: none;

            & > span::before {
                height: 1px !important;
            }

            @media ${getBreakpoint("up", "md")} {
                width: auto;
            }
        }
    }

    @media ${getBreakpoint("up", "sm")} {
        width: auto;
        margin-top: ${lexusTheme.space[0]};
        margin-${getDirection("left")}: auto;
        text-align: end;
    }

    @media ${getBreakpoint("up", "lg")} {
        grid-template-columns: ${({ columns }) => (columns === 1 ? "1fr" : "1fr 1fr")};
        grid-template-rows: 1fr;
        row-gap: 0;
        column-gap: ${lexusTheme.space[2]}px;
        max-width: 50%;
    }
`;

export const CategoryName = styled.h2.attrs(() => ({
    className: "l-base-text",
}))`
    margin-bottom: ${lexusTheme.space[1]}px;
    text-transform: uppercase;
    color: ${lexusTheme.colors.dark};
`;

export const CategoryDescription = styled.div`
    margin-top: ${lexusTheme.space[1]}px;
    font-size: 1.3rem;
    color: ${lexusTheme.colors.grey3};
`;

export const ModalInstallationDescription = styled.div`
    margin-bottom: ${lexusTheme.space[3]}px;
    color: ${lexusTheme.colors.grey3};
`;

export const Legend = styled.div`
    margin-top: ${lexusTheme.space[2]}px;
    margin-bottom: ${lexusTheme.space[5]}px;
    text-align: center;
    svg {
        width: 20px;
        margin: 0 ${lexusTheme.space[1]}px 0 0;
        fill: ${lexusTheme.colors.grey3} !important;
        @media ${getBreakpoint("up", "md")} {
            margin: 0 ${lexusTheme.space[1]}px 0 ${lexusTheme.space[3]}px;
        }
    }
    ${Type.SmallText} {
        margin-${getDirection("right")}: ${lexusTheme.space[3]}px;
        color: ${lexusTheme.colors.grey3};
        @media ${getBreakpoint("up", "md")} {
            margin: 0;
        }
    }
`;

export const WheelEULabelProps = styled(Flex.Col)`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin-top: ${lexusTheme.space[2]}px;
    margin-bottom: ${lexusTheme.space[2]}px;

    ${IconWrapper} {
        display: flex;
        align-items: center;
        margin: 0 ${lexusTheme.space[1]}px;
    }
`;
